import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

export function getJobDetails(jobId, jobCityWorkLocationId, isAuthenticated) {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${
          isAuthenticated ? apiEndpoints.JOBS : apiEndpoints.JOBS_SHARABLE
        }/${jobId}?jobCityWorkLocationId=${jobCityWorkLocationId}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}
export default {};
